import _ from 'lodash'

export default {
	template: `
    <div class="m-auto d-flex form-container">
    <div>
      <nk-input :options="settings.inputOptions" v-model="currentValue" @update:modelValue="onInputBoxChanged" />
    </div>
    <div class="mr-2 pt-1 d-flex" style="">
      <a class="input-button m-auto" style="" data-clear>
        <i class="fa fa-times " style="cursor:pointer" v-on:click="removeFilter"></i>
      </a>
    </div>
    </div>
	`,
	mounted() {
		this.settings = _.merge(this.settings, this.params.filterParams.options)
	},
	data: function () {
		return {
			currentValue: null,
			settings: {
				inputOptions: {
					mode: 'price',
				}
			},
		}
	},
	methods: {
		removeFilter() {
			this.currentValue = ''
			this.onInputBoxChanged()
		},
		onInputBoxChanged() {
			if (this.currentValue === '') {
				// Remove the filter
				this.params.parentFilterInstance((instance) => {
					instance.myMethodForTakingValueFromFloatingFilter(null)
				})
				return
			}

			this.params.parentFilterInstance((instance) => {
				instance.myMethodForTakingValueFromFloatingFilter(this.currentValue)
			})
		},

		onParentModelChanged(parentModel) {
			// console.log('floating',parentModel)
			// When the filter is empty we will receive a null value here
			if (parentModel == null) {
				this.currentValue = ''
			} else {
				this.currentValue = parentModel.filter || ''
			}
		},
	},
}
